export default "__VITE_ASSET__gUOpuwn4__"